import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query GetOrderSummaryByToken(
    $priceId: [MongoID]!
    $customerId: MongoID!
    $token: String!
    $countryCode: String
    $subscriptionDiscountId: [MongoID]
    $seats: Int
  ) {
    getOrderSummaryByToken(
      priceId: $priceId
      customerId: $customerId
      token: $token
      countryCode: $countryCode
      subscriptionDiscountId: $subscriptionDiscountId
      seats: $seats
    ) {
      amount
      description
      discount
      name
      quantity
      total
      unit
      type
      priceId
      nextBillingDate
      nextBillingAmount
    }
  }
`;
